import React from 'react';
import { useTemperatureUnit } from '../../contexts/TemperatureUnitContext';

const convertToFahrenheit = (celsius) => {
  return (celsius * 9/5) + 32;
};

const formatTemperature = (temp, unit) => {
  if (temp === undefined || temp === null) return '';
  const value = unit === 'F' ? convertToFahrenheit(temp) : temp;
  return `${value.toFixed(1)}°${unit}`;
};

const formatTemperatureDifference = (tempDiff, unit) => {
  if (tempDiff === undefined || tempDiff === null) return '';
  const value = unit === 'F' ? (tempDiff * 9/5) : tempDiff;
  return value.toFixed(1);
};

const TemperatureDisplay = ({ 
  temperature, 
  forecastHours, 
  temperatureComparisonText,
  minTemp,
  maxTemp 
}) => {
  const { unit } = useTemperatureUnit();

  // Extract the numeric value from the comparison text if it exists
  let modifiedComparisonText = temperatureComparisonText;
  if (temperatureComparisonText) {
    const matches = temperatureComparisonText.match(/(\d+\.?\d*)/);
    if (matches) {
      const originalDiff = parseFloat(matches[0]);
      const convertedDiff = formatTemperatureDifference(originalDiff, unit);
      modifiedComparisonText = temperatureComparisonText.replace(
        matches[0],
        convertedDiff
      );
    }
  }

  return (
    <div className="space-y-3">
      {temperature !== undefined && (
        <div>
          <p className="text-4xl font-light text-gray-800 dark:text-gray-200 flex items-center gap-3">
            {formatTemperature(temperature, unit)}
            {forecastHours > 0 && <span className="text-sm">({forecastHours}h forecast)</span>}
            {modifiedComparisonText && forecastHours === 0 && (
              <span className="text-sm text-gray-600 dark:text-gray-400">
                ({modifiedComparisonText})
              </span>
            )}
          </p>
        </div>
      )}
      
      <p className="text-sm text-gray-600 dark:text-gray-400">
        High: {formatTemperature(maxTemp, unit)}
      </p>
      <p className="text-sm text-gray-600 dark:text-gray-400">
        Low: {formatTemperature(minTemp, unit)}
      </p>
    </div>
  );
};

export default TemperatureDisplay;